import React, { Component } from "react";
import { Row, Col, CustomInput, Progress } from 'reactstrap';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback, AvCheckbox, AvCheckboxGroup, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { translations } from '../../../../translate.js';
import { Picky } from 'react-picky';
import 'react-picky/dist/picky.css';
import { CircularProgress } from "@material-ui/core";
let Strings = localStorage.getItem('LANG') == 1 ? translations.Ar : translations.En;


class AddTax extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: 0,
            startSave: 0,
            errorSelect: 0,
            submitError: '',
            errorCode: '',
            taxTypeList: this.props.taxTypeList,
            name: (this.props.status == 'add') ? '' : this.props.taxData['name'],
            name_en: (this.props.status == 'add') ? '' : this.props.taxData['nameEn'],
            taxType: (this.props.status == 'add') ? 0 : this.props.taxData['type'],
            taxValue: (this.props.status == 'add') ? 0 : this.props.taxData['taxValue'],
        }
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
    }
    //############################################# start Api ###################################################
    handleValidSubmit(event) {
        event.preventDefault();
        if (this.state.taxType == 0 || this.state.taxType == '') {
            this.setState({ errorSelect: 1 })
        } else {
            this.setState({ startSave: 1 })
            fetch(window.API_PERM_USER, {
                method: 'POST',
                body: JSON.stringify({
                    'type': 'addEditTax',
                    'lang': localStorage.getItem('LANG'),
                    'userId': localStorage.getItem('USER_ID'),
                    'token': localStorage.getItem('USER_TOKEN'),
                    'id': (this.props.status == 'add') ? '' : this.props.taxData['id'],
                    'taxType': this.state.taxType,
                    'taxValue': this.state.taxValue,
                    'name': this.state.name,
                    'nameEn': this.state.name_en
                }),
                headers: {
                    'Accept': 'application/json',
                },
            }).then(function (response) {
                return response.json();
            }).then(data => {
                if (data !== "Nothing found") {
                    if (data['logout'] == 1) {
                        localStorage.setItem('USER_ID', '');
                        localStorage.setItem('USER_TOKEN', '');
                        window.location.href = "/logout";
                    } else if (data['error'] == 1) {
                        this.setState({ submitError: data['errorMsg'], startSave: 0 })
                    } else {
                        this.props.handleFormAction()
                    }
                }
            })

        }
    }
    //############################################# end Api ###################################################
    //############################################# start React ###################################################
    setSelectOption = (option) => {
        return (
            <option value={option.id} key={option.id} data-name={option.name}>{option.name}</option>
        )
    }
    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value,
            submitError: '',
            errorSelect: 0
        })
    }
    handleChangeSelect = (event, id) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState(state => {
            return {
                [name]: value,
                error: 0
            }
        })
    }
    //############################################# end React ###################################################

    render() {
        return (
            <div className='view-modal-style'>
                <div className='sidebar-header-view'>
                    <Row>
                        <Col lg={10} md={10} sm={10} xs={10}>
                            <div className='p-0 main-color-1  sidebar-header-title'>  {this.props.status == 'add' ? Strings['Add'] : Strings['Edit']} {Strings['Tax']}
                            </div>
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2} className='text-right'>
                            <HighlightOffIcon onClick={this.props.handleCloseSideBar} className='modal-close-icon' />
                        </Col>
                    </Row>
                </div>

                <div className='sidebar-body-view'>
                    <AvForm onValidSubmit={this.handleValidSubmit} ref={c => (this.form = c)}>
                        <AvField name="name" label={Strings['Tax Name'] + ' *'} placeholder={Strings['Enter Tax Name']} value={this.state.name} required onChange={this.handleInputChange} errorMessage={Strings['This field is required']} />
                        <AvField name="name_en" label={Strings['Tax Name In English'] + ' *'} placeholder={Strings['Enter Tax Name In English']} value={this.state.name_en} required onChange={this.handleInputChange} errorMessage={Strings['This field is required']} />
                        <AvField name="taxValue" label={Strings['Tax Value'] + ' *'} placeholder={Strings['Tax Value']} value={this.state.taxValue} required onChange={this.handleInputChange} errorMessage={Strings['This field is required']} />

                        <div className=' mb-2'>
                            <AvField label={Strings['Tax Type'] + ' *'} type="select" name="taxType" value={this.state.taxType} onChange={(event) => this.handleInputChange(event)} required errorMessage={Strings['This field is required']}   >
                                <option style={{
                                    'display': 'block'
                                }} value="" defaultValue>{Strings['Select Tax Type']}</option>
                                {this.state.taxTypeList.map((option) => this.setSelectOption(option))}
                            </AvField>
                        </div>

                        <div className='text-right mt-4'>
                            {this.state.error == 0 &&
                                <>
                                    {this.state.startSave == 0 ?
                                        <button type="submit" className="btn form-save-btn mr-1 ml-1"> {Strings['Save']} </button>
                                        :
                                        <button type="button" className="btn form-save-btn mr-1 ml-1"><CircularProgress className="SaveCircularProgressColor" /> {Strings['Save']}</button>
                                    }
                                </>
                            }
                            <button type="button" className="btn form-cancel-btn m-l-10" onClick={this.props.handleCloseSideBar}>{Strings['Cancel']}</button>
                        </div>

                        {this.state.submitError &&
                            <div className='error-text-black'><i className='flaticon2-exclamation error-icon mr-1' /> {this.state.submitError}</div>
                        }
                    </AvForm>
                </div>
            </div>
        )
    }
}
export default AddTax;